import React, { useState } from "react";
import { GetSplitMyPartyAccInfo } from "../../../../../Api/ApiCommon";
import { secodaryMailConverter } from "../../../../../scCommon/scCommonFunc";
import { TableBodyItem } from "../../../../Table/Table";
import { IPartyDetailMemberInfo } from "../PartyDetailMemberInfo";
import PartyMailModal from "../PartyDetailShareInfo/PartyMailModal";
import {
  getShareDefData,
  GetSubscriptionSetData_V3,
} from "../../../../../ApiTS/ServiceDatasTS_V3";
import { getString3ByKey } from "../../../../../AdminApi/3.0_utils";

interface LinkidEmailItemProps {
  partyId?: string;
  subsId: number;
  d: IPartyDetailMemberInfo;
}

export default function LinkidEmailItem({
  partyId,
  subsId,
  d,
}: LinkidEmailItemProps) {
  const [mailModal, setMailModal] = useState(false);
  const [mailPartyData, setMailPartyData] = useState({
    member: "",
    memberEmail: "",
    party: "",
    emailRegTime: "",
  });

  const subsData = GetSubscriptionSetData_V3(subsId ?? 0);
  const shareDefData = subsData
    ? getShareDefData(subsData?.SHARDEF_ID ?? 0, 0)
    : undefined;

  const isInviteExtra = shareDefData
    ? shareDefData?.SHARDEF_TYP === "invite_extra" ||
      shareDefData?.SHARDEF_TYP === "invite_lkdextra"
    : false;

  const hasLinkidMail = d?.linkidmail && d?.linkidmail?.length > 0;
  const linkidMail = d?.linkidmail;

  const memberShareId = GetSplitMyPartyAccInfo(d?.shareid ?? "")?.id ?? "";

  const email =
    isInviteExtra && d?.grade === 0
      ? "-"
      : isInviteExtra
      ? memberShareId && memberShareId?.length > 0
        ? memberShareId
        : secodaryMailConverter(
            Number(d?.ownerid),
            subsData?.SVC_ID ?? 0,
            d?.pindex ?? 0,
            undefined
          )
      : hasLinkidMail
      ? linkidMail
      : "-";

  return (
    <>
      <TableBodyItem
        clickable={d?.grade !== 0 && email !== "-" ? true : false}
        onClick={() => {
          if (d?.grade !== 0 && email !== "-") {
            setMailPartyData({
              member: `${d?.uid}_${d?.name}_${d?.nickname}`,
              memberEmail: email,
              party: `${partyId}_${getString3ByKey(subsData?.SUBS_NM ?? 0)}`,
              emailRegTime: `${
                d?.shareinfoUpdate ??
                `${d?.joindate} ${d?.jointime ?? "00:00:00"}`
              }`,
            });
            setMailModal(true);
          }
        }}
      >
        {email}
      </TableBodyItem>

      {/* 링키드 메일 모달 */}
      {mailModal && (
        <PartyMailModal
          closeEvent={() => setMailModal(false)}
          partyData={mailPartyData}
          secondaryMailAcc={
            email?.includes("linkidmail.net")
              ? secodaryMailConverter(
                  Number(d?.ownerid),
                  subsData?.SVC_ID ?? 0,
                  d?.pindex ?? 0,
                  undefined
                )
              : undefined
          }
          type={email?.includes("linkidmail.net") ? "mailgun" : "db"}
        />
      )}
    </>
  );
}
